var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 7.64918C18.2368 7.4949 18.1404 7.35934 18.0118 7.25923C17.8833 7.15912 17.7282 7.09884 17.5658 7.08584L12.815 6.70834L10.7591 2.15751C10.6937 2.01094 10.5872 1.88645 10.4525 1.79906C10.3179 1.71167 10.1608 1.66513 10.0003 1.66504C9.83972 1.66495 9.68259 1.71132 9.54784 1.79856C9.41308 1.8858 9.30645 2.01018 9.24082 2.15668L7.18498 6.70834L2.43415 7.08584C2.27453 7.09849 2.12193 7.15685 1.99461 7.25395C1.86729 7.35105 1.77064 7.48278 1.71623 7.63337C1.66181 7.78396 1.65193 7.94704 1.68777 8.1031C1.72361 8.25916 1.80365 8.40158 1.91831 8.51334L5.42915 11.9358L4.18748 17.3125C4.14978 17.4753 4.16186 17.6456 4.22216 17.8014C4.28247 17.9572 4.3882 18.0913 4.52565 18.1862C4.6631 18.2812 4.82591 18.3326 4.99297 18.3339C5.16002 18.3352 5.3236 18.2862 5.46248 18.1933L9.99998 15.1683L14.5375 18.1933C14.6794 18.2876 14.8468 18.3361 15.0172 18.3324C15.1875 18.3286 15.3526 18.2728 15.4903 18.1724C15.628 18.0721 15.7316 17.9319 15.7873 17.7709C15.8429 17.6099 15.848 17.4356 15.8016 17.2717L14.2775 11.9383L18.0575 8.53668C18.305 8.31334 18.3958 7.96501 18.2891 7.64918V7.64918Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.76bdb6e8cbd56d8f348f2a26434b8697.svg";
export { ForwardRef as ReactComponent };